import assign from 'lodash/assign';
import * as APIS from '../../constants/api';

export const campaignManagement =
  (action, payload) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.CAMPAIGN_MANAGEMENT, assign({ action }, payload))
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const x = 14;
